export const citiesList = (state) => state.cities.citiesReducer;
export const loading = (state) => state.cities.loadingReducer;
export const error = (state) => state.cities.errorReducer;

